module.exports = __webpack_public_path__ + "img/box-nothing.92807716.svg";